
import { Vue, Component, Prop, ModelSync } from "vue-property-decorator";
import VideoInput from "@/components/Reusable/CustomInputs/VideoInput.vue";
import { Control } from "@/oxygen/classes/lib/types";
import { OEmbed } from "@/types/controls";

@Component({
  components: { VideoInput }
})
export default class OxygenVideoInput extends Vue {
  @Prop()
  control!: Control;

  @ModelSync("value", "input")
  syncedValue?: OEmbed;

  @Prop()
  placeholder?: OEmbed;
}
